import {
  Card,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Button,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { useState } from "react";

import Help from "~/components/common/Help";
import SupplyChangeReasonRow, { SupplyChangeReasonDialog } from "./SupplyChangeReasonRow";
import { SupplyChangeReasonEventTypeEnum } from "~/graphql/__generated__/graphql";
import { sortBy } from "lodash";

const TabSupplyReasons = () => {
  const { supplyChangeReasons, loading } = useOrgConfig();
  
  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const reasons = sortBy(Object.values(supplyChangeReasons), ["eventType", "label"]);

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Card sx={{ height: "100%" }}>
        <TableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '10%', maxWidth: '120px' }}>Event</TableCell>
                <TableCell sx={{ width: '75%', maxWidth: '500px' }}>
                  Supply Change Reason
                  <Help text="Reason that can be selected when adding or removing supplies from inventory." />
                </TableCell>
                <TableCell sx={{ width: '15%', maxWidth: '100px' }}>Active</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <>
                  <RowSkeleton />
                  <RowSkeleton />
                  <RowSkeleton />
                </>
              ) : reasons.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} sx={{ textAlign: "center" }}>
                    No supply change reasons found
                  </TableCell>
                </TableRow>
              ) : (
                reasons.map((reason) => (reason && <SupplyChangeReasonRow key={reason.id} reason={reason} />))
              )}
            <TableRow>
              <TableCell colSpan={2}>
                <Button
                  onClick={() => setCreateDialogOpen(true)}
                  size="small"
                  startIcon={<AddCircleOutlineIcon fontSize="small" />}
                >
                  Add New Supply Change Reason
                </Button>
              </TableCell>
            </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {createDialogOpen && <SupplyChangeReasonDialog
        reason={{ label: "", active: true, id: 0, eventType: SupplyChangeReasonEventTypeEnum.Deposit }}
        onClose={() => setCreateDialogOpen(false)}
      />}
    </Container>
  );
};

export default TabSupplyReasons;

const RowSkeleton = () => (
  <TableRow>
    <TableCell sx={{ width: '10%', maxWidth: '120px' }}>
      <Skeleton width="100%" />
    </TableCell>
    <TableCell sx={{ width: '75%', maxWidth: '500px' }}>
      <Skeleton width="100%" />
    </TableCell>
    <TableCell sx={{ width: '15%', maxWidth: '100px' }}>
      <Skeleton width="100%" />
    </TableCell>
  </TableRow>
);
